import React, { useState, useEffect, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import {
  TextField,
  Typography,
  Container,
  Button,
  Paper,
  Grid,
  Tooltip,
  IconButton,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Box,
  InputAdornment,
} from '@mui/material';
import {
  contarDifusionesDelDia,
  enviarMensaje,
  obtenerDifusionesDelDia,
  obtenerLeidoPor,
} from '../../actions/NotasAction';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import SendIcon from '@mui/icons-material/Send';
import MessageIcon from '@mui/icons-material/Message';
import GetAppIcon from '@mui/icons-material/GetApp';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import { useStateValue } from '../../contexto/store';
import { obtenerUsuarioConImagen } from '../../actions/UsuariosAction';
import { downloadFile } from '../../actions/ArchivosAction';
import { Visibility } from '@mui/icons-material';

const NuevaDifusion = () => {
  const [lista, setLista] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [{ sesionUsuario }] = useStateValue();
  const [leidopor, setLeidoPor] = useState([]);
  const [mensaje, setMensaje] = useState({
    Texto: '',
  });
  const dialogHandleClose = () => {
    setOpenDialog(false);
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setMensaje((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const mounted = useRef(true);
  const Enviar = () => {
    let NOTA = {
      Texto: mensaje.Texto,
      DIFUSION: 'SI',
      RemitenteUserName: sesionUsuario.usuario.userName,
    };
    enviarMensaje(NOTA).then((response) => {
      if (response.status === 200) {
        setMensaje({
          Texto: '',
        });
        contarDifusionesDelDia();
      }
    });
  };
  const descargarArchivo = (url) => {
    downloadFile(url);
  };
  const verLeidoPor = (nota) => {
    obtenerLeidoPor(nota.Id).then((response) => {
      if (response.status === 200) {
        setLeidoPor([]);
        response.data.map((data) => {
          setLeidoPor((anterior) => [...anterior, data.leidopor + ', ']);
          return leidopor;
        });
      }
    });
    setOpenDialog(true);
  };
  useEffect(() => {
    if (mounted.current) {
      obtenerDifusionesDelDia().then((response) => {
        if (response.status === 200) {
          response.data.map((data) => {
            obtenerUsuarioConImagen(data.remitenteUserName).then((response) => {
              setLista((anterior) => [
                ...anterior,
                {
                  Texto: data.texto,
                  UserName: response.data.userName,
                  Token: response.data.token,
                  Email: response.data.email,
                  NOMBRECOMPLETO: response.data.nombrecompleto,
                  imagenPerfil: response.data.imagenPerfil,
                  Id: data.notA_Id,
                  Fecha: data.fecgra,
                },
              ]);
            });
            return null;
          });
        }
      });
      const hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(
          'http://192.168.0.11:443/chatHub?username=' +
            sesionUsuario.usuario.userName
        )
        .build();
      hubConnection
        .start()
        .catch((err) => console.error('SignalR Connection Error: ', err));
      hubConnection.on('Enviando', (NOTA) => {
        obtenerUsuarioConImagen(sesionUsuario.usuario.userName).then(
          (response) => {
            setLista((anterior) => [
              ...anterior,
              {
                Texto: NOTA.texto,
                UserName: response.data.userName,
                Token: response.data.token,
                Email: response.data.email,
                NOMBRECOMPLETO: response.data.nombrecompleto,
                imagenPerfil: response.data.imagenPerfil,
                Id: NOTA.notA_Id,
                Fecha: NOTA.fecgra,
              },
            ]);
          }
        );
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [lista, sesionUsuario]);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 4,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AnnouncementIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Nueva Difusión
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.9)', mt: 0.5 }}
            >
              {sesionUsuario.usuario.nombrecompleto}
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        {/* <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
          Difusiones del día:
        </Typography>

        <List sx={{ mb: 3 }}>
          {lista.map((lista) => (
            <Box
              key={lista.Texto}
              sx={{
                mb: 2,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                backgroundColor: 'background.paper',
              }}
            >
              <ListItem sx={{ px: 0 }}>
                <ListItemAvatar>
                  <Avatar alt="Profile Picture" src={lista.imagenPerfil} />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      Difusión de {lista.NOMBRECOMPLETO}
                    </Typography>
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        color="textPrimary"
                        sx={{ display: 'block', my: 1 }}
                      >
                        {lista.Texto}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        A las {lista.Fecha.substr(11, 6)} hs
                      </Typography>
                    </React.Fragment>
                  }
                />
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  {lista.Archivo === undefined ||
                  lista.Archivo === 'undefined' ||
                  lista.Archivo === null ? null : (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<GetAppIcon />}
                      onClick={() => descargarArchivo(lista.Archivo)}
                      sx={{
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        mr: 1,
                      }}
                    >
                      Descargar
                    </Button>
                  )}
                  <Tooltip title="Leído por">
                    <IconButton
                      onClick={() => verLeidoPor(lista)}
                      sx={{
                        backgroundColor: 'primary.main',
                        color: 'white',
                        '&:hover': {
                          backgroundColor: 'primary.dark',
                        },
                      }}
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>
                </Box>
              </ListItem>
            </Box>
          ))}
        </List> */}

        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
            Enviar Nueva Difusión
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                name="Texto"
                value={mensaje.Texto}
                variant="outlined"
                onChange={ingresarValoresMemoria}
                label="Mensaje"
                multiline
                rows={4}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start" sx={{ alignSelf: 'flex-start', mt: 2 }}>
                      <MessageIcon sx={{ fontSize: 20, color: 'action.active', mr: 1.5 }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SendIcon />}
                onClick={Enviar}
                sx={{
                  borderRadius: 2,
                  textTransform: 'none',
                  fontWeight: 600,
                  py: 1.5,
                  px: 4,
                }}
              >
                Enviar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>

      <Dialog
        component={'div'}
        open={openDialog}
        onClose={dialogHandleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle component={'div'} id="form-dialog-title">
          Visto Por:{' '}
        </DialogTitle>
        <DialogContent component={'div'}>
          <DialogContentText component={'div'}>
            <Typography>{leidopor}</Typography>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Container>
  );
};
export default NuevaDifusion;
